export default "__VITE_ASSET__4008eddd__"